import { render, staticRenderFns } from "./AssessmentPrompt.vue?vue&type=template&id=360de4c0&scoped=true"
import script from "./AssessmentPrompt.vue?vue&type=script&lang=js"
export * from "./AssessmentPrompt.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPrompt.vue?vue&type=style&index=0&id=360de4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360de4c0",
  null
  
)

export default component.exports